import { useCallback } from 'react';
import type { Session } from '../../../../core/domain/Session';
import { ZoomOnSessionCommand } from '../../../../core/networkMap/commands/ZoomOnSessionCommand';
import { useCommand } from '../../../store';

const useZoomOnSession = (session: Session): (() => void) => {
    const zoomOnSession = useCommand(ZoomOnSessionCommand);

    return useCallback((): void => {
        zoomOnSession(session.id);
    }, [session]);
};

export default useZoomOnSession;
